import React from 'react'
import Page from './Page'
import { MetaWrapper } from '../../components/Meta'
import { structuredData } from '../../SEO/HomePage/structuredData'
import { logoStructuredData } from '../../SEO/logoStructuredData'
import { useSiteQuery } from '@graphql/queries/__generated__/site.generated'
import { PROFILE_ORDER_HISTORY_URL } from '../../urls'
import { Redirect } from 'react-router-dom'
import WholesaleMode from '@components/WholesaleMode'

interface ViewProps {}

const View: React.FC<ViewProps> = ({}) => {
  const siteQuery = useSiteQuery({ fetchPolicy: 'cache-first' })
  return (
    <MetaWrapper>
      {siteQuery.data && (
        <script className='structured-data-list' type='application/ld+json'>
          {structuredData(siteQuery.data.siteSettings)}
        </script>
      )}
      <script className='structured-data-list' type='application/ld+json'>
        {logoStructuredData()}
      </script>
      <WholesaleMode>
        <Redirect to={PROFILE_ORDER_HISTORY_URL} />
      </WholesaleMode>
      <WholesaleMode hide>
        <Page />
      </WholesaleMode>
    </MetaWrapper>
  )
}

export default View
